/* eslint-disable */
import { Theme, StyleRules } from '@material-ui/core/styles';

import QuillSnowStylesheet from './QuillSnowStylesheet';

export default (theme: Theme): StyleRules<string, any> => ({
  '@global': {
    ...QuillSnowStylesheet,
    '.ql-editor': {
      fontSize: '1rem',
      fontFamily: 'Roboto, sans-serif',
      padding: '6px 12px',
      minHeight: '100px',
      userSelect: 'text',

      '&:hover::before': {
        height: 2,
      },

      '&::before': {
        left: 0,
        right: 0,
        bottom: 0,
        height: 1,
        content: '""',
        position: 'absolute',
      },

      '&::after': {
        left: 0,
        right: 0,
        bottom: 0,
        height: 2,
        content: '""',
        position: 'absolute',
        transform: 'scaleX(0)',
      },

      '& p:not(:last-child)': {
        marginBottom: '1rem',
      },

      '& strong': {
        fontWeight: 700,
      },
      '& h1': {
        margin: '1rem 0 0.5rem 0',
        fontWeight: 500,
      },
      '& h2': {
        margin: '1rem 0 0.5rem 0',
        fontWeight: 500,
      },
      '& h3': {
        margin: '1rem 0 0.5rem 0',
        fontWeight: 500,
      },
      '& img': {
        cursor: 'pointer',
      },
      '& ul': {
        marginBottom: '1rem',
      },

      '&:focus::after': {
        transform: 'scaleX(1)',
      },
    },
    '& .standard .ql-editor': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .outlined .ql-editor': {
      backgroundColor: theme.palette.background.paper,
    },
    '& .ql-toolbar.ql-snow': {
      margin: '0.5rem 0',
      border: 0,
      padding: 0,

      '& .ql-picker-item': {
        color: theme.palette.text.primary,
      },
      '& .ql-stroke': {
        stroke: theme.palette.text.primary,
      },
      '& .ql-fill': {
        fill: theme.palette.text.primary,
      },
      '& .ql-picker-item.ql-active': {
        color: theme.palette.primary.main,
      },
      '& .ql-picker-item:hover': {
        color: theme.palette.primary.main,
      },
      '& .ql-picker-item.ql-selected': {
        color: theme.palette.primary.main,
      },
      '& .ql-picker-label.ql-active': {
        color: theme.palette.primary.main,
      },
      '& .ql-picker-label.ql-selected': {
        color: theme.palette.primary.main,
      },
      '& .ql-picker-label:hover': {
        color: theme.palette.primary.main,
      },

      '& button:hover .ql-fill': {
        fill: theme.palette.primary.main,
      },
      '& button.ql-active .ql-fill': {
        fill: theme.palette.primary.main,
      },

      '& button:hover .ql-stroke': {
        stroke: theme.palette.primary.main,
      },
      '& button.ql-active .ql-stroke': {
        stroke: theme.palette.primary.main,
      },
      '& .ql-picker-label:hover .ql-stroke': {
        stroke: theme.palette.primary.main,
      },

      '& .ql-picker.ql-expanded .ql-picker-options': {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.background.paper,
      },

      '& .ql-snow .ql-picker.ql-expanded .ql-picker-options': {
        background: '#fff',
        zIndex: 10,
      },

      '& .ql-picker-label': {
        paddingLeft: 0,
        color: theme.palette.text.primary,
      },

      '& + .ql-container.ql-snow': {
        border: 0,
      },
    },
  },
});
